// NOTE: Добавление react-is может увеличить стабильность решения в определении типа элемента,
//   однако также расширит размер бандла

export var isFiberNodeKey = function isFiberNodeKey(key) {
  return key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$') || key.startsWith('__reactContainer');
};
export var getFiberNodeType = function getFiberNodeType(fiberNode) {
  return fiberNode.type;
};
export var getFiberProps = function getFiberProps(fiberNode) {
  return fiberNode.memoizedProps;
};
export var getFiberProp = function getFiberProp(fiberNode, propName) {
  var _getFiberProps;
  return (_getFiberProps = getFiberProps(fiberNode)) === null || _getFiberProps === void 0 ? void 0 : _getFiberProps[propName];
};
export var isDomFiberNode = function isDomFiberNode(fiberNode) {
  return typeof getFiberNodeType(fiberNode) === 'string';
};
export var isRootFiberNode = function isRootFiberNode(fiberNode) {
  return fiberNode.return === null;
};
export var getFiberNodeFromClassComponent = function getFiberNodeFromClassComponent(classComponent) {
  return classComponent._reactInternals;
};
/**
 * Для обычных узлов stateNode хранит указатель на DOM-элемент
 *   Однако для корневого узла, ссылка хранится дальше - в containerInfo
 */
export var getDomNodeFromFiber = function getDomNodeFromFiber(fiberNode) {
  var node = fiberNode === null || fiberNode === void 0 ? void 0 : fiberNode.stateNode;
  return node instanceof HTMLElement ? node : node === null || node === void 0 ? void 0 : node.containerInfo;
};
export function getFiberNodeFromDOM(domNode) {
  var internalInstanceKey = Object.keys(domNode).find(isFiberNodeKey);
  if (!internalInstanceKey) throw new Error('Не удается получить доступ к FiberNode из текущего dom-элемента. ' + 'Возможно использована несовместимая версия React, ' + 'либо элемент не находится под управлением React');
  return domNode[internalInstanceKey];
}
export function getFiberNodeParent(fiberNode) {
  if (fiberNode && fiberNode.return) {
    return fiberNode.return; // This is the parent Fiber node
  }

  return null; // Return null if there is no parent
}

export function getContextAtNode(domNode, Context) {
  var contextNode = findClosestFiberNodeMatching(getFiberNodeFromDOM(domNode), function (checkNode) {
    return getFiberNodeType(checkNode) === Context.Provider;
  });
  if (!contextNode) throw new Error('Провайдер авто-метрики не найден в контексте текущего узла, возможно вы забыли подключить');
  return getFiberProp(contextNode, 'value');
}
export function findClosestFiberNodeMatching(fiberNode, matcher) {
  while (fiberNode && !matcher(fiberNode)) {
    fiberNode = getFiberNodeParent(fiberNode);
  }
  return fiberNode;
}
export function findDOMParent(component) {
  return getDomNodeFromFiber(findClosestFiberNodeMatching(getFiberNodeFromClassComponent(component), function (checkNode) {
    return isDomFiberNode(checkNode) || isRootFiberNode(checkNode);
  }));
}